
export const languageCodes = [
  {
    "code": "en",
    "name": "English",
    "count": 85676368
  },
  {
    "code": "es",
    "name": "Spanish",
    "count": 52903640
  },
  {
    "code": "pt",
    "name": "Portuguese",
    "count": 50755392
  },
  {
    "code": "fr",
    "name": "French",
    "count": 36107831
  },
  {
    "code": "ar",
    "name": "Arabic",
    "count": 33873829
  },
  {
    "code": "ru",
    "name": "Russian",
    "count": 32965538
  },
  {
    "code": "it",
    "name": "Italian",
    "count": 26420479
  },
  {
    "code": "de",
    "name": "German",
    "count": 24183913
  },
  {
    "code": "fa",
    "name": "Persian",
    "count": 22403637
  },
  {
    "code": "id",
    "name": "Indonesian",
    "count": 20767560
  },
  {
    "code": "tr",
    "name": "Turkish",
    "count": 19935278
  },
  {
    "code": "ja",
    "name": "Japanese",
    "count": 9293813
  },
  {
    "code": "pl",
    "name": "Polish",
    "count": 8251514
  },
  {
    "code": "th",
    "name": "Thai",
    "count": 6117254
  },
  {
    "code": "zh",
    "name": "Chinese",
    "count": 5947633
  },
  {
    "code": "hi",
    "name": "Hindi",
    "count": 5505423
  },
  {
    "code": "uk",
    "name": "Ukrainian",
    "count": 4672098
  },
  {
    "code": "ms",
    "name": "Malay",
    "count": 4638316
  },
  {
    "code": "ko",
    "name": "Korean",
    "count": 4432753
  },
  {
    "code": "nl",
    "name": "Dutch",
    "count": 4406889
  },
]

export const interestCodes = [
  {
    "name": "Television & Film",
    "id": 1
  },
  {
    "name": "Music",
    "id": 3
  },
  {
    "name": "Shopping & Retail",
    "id": 7
  },
  {
    "name": "Coffee, Tea & Beverages",
    "id": 9
  },
  {
    "name": "Camera & Photography",
    "id": 11
  },
  {
    "name": "Clothes, Shoes, Handbags & Accessories",
    "id": 13
  },
  {
    "name": "Beer, Wine & Spirits",
    "id": 19
  },
  {
    "name": "Sports",
    "id": 21
  },
  {
    "name": "Electronics & Computers",
    "id": 25
  },
  {
    "name": "Gaming",
    "id": 30
  },
  {
    "name": "Activewear",
    "id": 33
  },
  {
    "name": "Art & Design",
    "id": 36
  },
  {
    "name": "Travel, Tourism & Aviation",
    "id": 43
  },
  {
    "name": "Business & Careers",
    "id": 58
  },
  {
    "name": "Beauty & Cosmetics",
    "id": 80
  },
  {
    "name": "Healthcare & Medicine",
    "id": 100
  },
  {
    "name": "Jewellery & Watches",
    "id": 130
  },
  {
    "name": "Restaurants, Food & Grocery",
    "id": 139
  },
  {
    "name": "Toys, Children & Baby",
    "id": 190
  },
  {
    "name": "Fitness & Yoga",
    "id": 196
  },
  {
    "name": "Wedding",
    "id": 291
  },
  {
    "name": "Tobacco & Smoking",
    "id": 405
  },
  {
    "name": "Pets",
    "id": 673
  },
  {
    "name": "Healthy Lifestyle",
    "id": "798"
  },
  {
    "name": "Luxury Goods",
    "id": 1500
  },
  {
    "name": "Home Decor, Furniture & Garden",
    "id": 1560
  },
  {
    "name": "Friends, Family & Relationships",
    "id": 1708
  },
  {
    "name": "Cars & Motorbikes",
    "id": 1826
  }
];

export const countryCodes = [
  {
    "id": 148838,
    "name": "United States",
    "title": "United States"
  },
  {
    "id": 2202162,
    "name": "France",
    "title": "France"
  },
  {
    "id": 60189,
    "name": "Russia",
    "title": "Russia"
  },
  {
    "id": 1428125,
    "name": "Canada",
    "title": "Canada"
  },
  {
    "id": 1311341,
    "name": "Spain",
    "title": "Spain"
  },
  {
    "id": 62149,
    "name": "United Kingdom",
    "title": "United Kingdom"
  },
  {
    "id": 59470,
    "name": "Brazil",
    "title": "Brazil"
  },
  {
    "id": 114686,
    "name": "Mexico",
    "title": "Mexico"
  },
  {
    "id": 51477,
    "name": "Germany",
    "title": "Germany"
  },
  {
    "id": 304751,
    "name": "Indonesia",
    "title": "Indonesia"
  },
  {
    "id": 365331,
    "name": "Italy",
    "title": "Italy"
  },
  {
    "id": 174737,
    "name": "Turkey",
    "title": "Turkey"
  },
  {
    "id": 304716,
    "name": "India",
    "title": "India"
  },
  {
    "id": 80500,
    "name": "Australia",
    "title": "Australia"
  },
  {
    "id": 556706,
    "name": "New Zealand",
    "title": "New Zealand"
  },
  {
    "id": 1473947,
    "name": "Egypt",
    "title": "Egypt"
  },
  {
    "id": 307763,
    "name": "United Arab Emirates",
    "title": "United Arab Emirates"
  },
  {
    "id": 295480,
    "name": "Portugal",
    "title": "Portugal"
  },
  {
    "id": 16239,
    "name": "Austria",
    "title": "Austria"
  },
  {
    "id": 72596,
    "name": "Lithuania",
    "title": "Lithuania"
  },
  {
    "id": 50046,
    "name": "Denmark",
    "title": "Denmark"
  },
  {
    "id": 51701,
    "name": "Switzerland",
    "title": "Switzerland"
  },
  {
    "id": 304938,
    "name": "Iran",
    "title": "Iran"
  },
  {
    "id": 192307,
    "name": "Greece",
    "title": "Greece"
  },
  {
    "id": 49715,
    "name": "Poland",
    "title": "Poland"
  },
  {
    "id": 120027,
    "name": "Colombia",
    "title": "Colombia"
  },
  {
    "id": 286393,
    "name": "Argentina",
    "title": "Argentina"
  },
  {
    "id": 270056,
    "name": "China",
    "title": "China"
  },
  {
    "id": 2067731,
    "name": "Thailand",
    "title": "Thailand"
  },
  {
    "id": 52411,
    "name": "Belgium",
    "title": "Belgium"
  },
  {
    "id": 443174,
    "name": "Philippines",
    "title": "Philippines"
  },
  {
    "id": 167454,
    "name": "Chile",
    "title": "Chile"
  },
  {
    "id": 536780,
    "name": "Singapore",
    "title": "Singapore"
  },
  {
    "id": 52822,
    "name": "Sweden",
    "title": "Sweden"
  },
  {
    "id": 192787,
    "name": "Nigeria",
    "title": "Nigeria"
  },
  {
    "id": 2323309,
    "name": "The Netherlands",
    "title": "The Netherlands"
  },
  {
    "id": 307756,
    "name": "South Korea",
    "title": "South Korea"
  },
  {
    "id": 87565,
    "name": "South Africa",
    "title": "South Africa"
  },
  {
    "id": 2108121,
    "name": "Malaysia",
    "title": "Malaysia"
  },
  {
    "id": 60199,
    "name": "Ukraine",
    "title": "Ukraine"
  },
  {
    "id": 307573,
    "name": "Pakistan",
    "title": "Pakistan"
  },
  {
    "id": 1473946,
    "name": "Israel",
    "title": "Israel"
  },
  {
    "id": 49915,
    "name": "Vietnam",
    "title": "Vietnam"
  },
  {
    "id": 2978650,
    "name": "Norway",
    "title": "Norway"
  },
  {
    "id": 54224,
    "name": "Finland",
    "title": "Finland"
  },
  {
    "id": 449220,
    "name": "Taiwan",
    "title": "Taiwan"
  },
  {
    "id": 28699,
    "name": "Georgia",
    "title": "Georgia"
  },
  {
    "id": 186382,
    "name": "Bulgaria",
    "title": "Bulgaria"
  },
  {
    "id": 59065,
    "name": "Belarus",
    "title": "Belarus"
  },
  {
    "id": 21335,
    "name": "Hungary",
    "title": "Hungary"
  },
  {
    "id": 214885,
    "name": "Croatia",
    "title": "Croatia"
  },
]

export const weightsList = [
  {
    label: '>10%',
    value: 0.1
  },
  {
    label: '>20%',
    value: 0.2
  },
  {
    label: '>30%',
    value: 0.3
  },
  {
    label: '>40%',
    value: 0.4
  },
  {
    label: '>50%',
    value: 0.5
  },
  {
    label: '>60%',
    value: 0.6
  },
  {
    label: '>70%',
    value: 0.7
  }
]
